module.exports = __webpack_public_path__ + "img/Cosplay.e3d4f797.svg";